import { http, httpV2 } from "@/api";

const Qs = require("qs");

const Get = function(monitoringElementId)
{
	return httpV2.get(`WindTurbines/${monitoringElementId}`);
};

/**
* @summary Solicita os equipamentos de uma turbina.
* @param {number} monitoringElementId Id do elemento de monitoração da turbina.
* @returns {array} Array com os equipamentos de uma turbina.
*/
const GetWindTurbineEquipments = function(monitoringElementId)
{
	return httpV2.get(`WindTurbines/${monitoringElementId}/Equipments`);
};

/**
 * Insere um novo evento de manutenção com arquivos anexos.
 * @param {object} parameters Parâmetros da requisição.
 */
const CreateEvent = function(parameters)
{
	const { id,  files } = parameters;

	return httpV2.post(`/WindTurbines/${id}/MaintenanceEventRecord`,
	 files,
	 { headers: { "Content-Type": "multipart/ -data, boundary=----WebKitFormBoundaryNhECEUcQhR0mSaia" }, });
};

/**
 * Solicita os eventos de manutenção cadastrados para esta turbina em um período.
 * @param {object} parameters Parâmetros da requisição.
 */
const GetEvents = function(parameters)
{
	const {
		monitoringElementId,
		startDateTime,
		endDateTime
	} = parameters;

	const params = {};
	params.startDateTime = startDateTime;
	params.endDateTime = endDateTime;

	return httpV2.get(`WindTurbines/${monitoringElementId}/MaintenanceEventRecords`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};

/**
 * Solicita os eventos de manutenção mais recentes cadastrados para esta turbina.
 * @param {number} parameters Id do evento.
 */
const GetLatestEvents = function(parameters)
{
	const { monitoringElementId,  numberOfRecords } = parameters;

	const params = {};
	params.numberOfRecords = numberOfRecords;

	return httpV2.get(`WindTurbines/${monitoringElementId}/LatestMaintenanceEventRecords`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};

/**
 * Solicita as notificações ocorridas para a unidade geradora.
 * @param {number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @param {number} startDateTime Data/hora de início.
 * @param {number} endDateTime Data/hora de fim.
 * @returns Array de notificações ocorridas para a unidade geradora.
 */
const GetNotificationsLogs = function(monitoringElementId, startDateTime, endDateTime)
{
	return http.get(`/WindTurbineEventsLog/
		${monitoringElementId}?startDateTime=
		${startDateTime}&endDateTime=
		${endDateTime}`);
};

export default {
	Get,
	GetWindTurbineEquipments,
	CreateEvent,
	GetEvents,
	GetLatestEvents,
	GetNotificationsLogs,
};